import IconPicker from '../../../scripts/iconpicker-1.5.0.js';

angular.module("cmsArticles")

    .controller("CmsArticlesEditCtrl", ['LoginService', '$scope', '$rootScope', '$controller', '$state', '$stateParams', 'Restangular', '$uibModal', 'modalService', '$compile', 'gridService', '$filter', '$translate', '$q', 'logService',
        function (LoginService, $scope, $rootScope, $controller, $state, $stateParams, Restangular, $uibModal, modalService, $compile, gridService, $filter, $translate, $q, logService) {

        //Comprobamos si tiene permiso escritura
        $scope.allowWrite = LoginService.permissionExist("CMS_CATEGORIES_WRITE");
        $rootScope.title = $filter('translate')('cms_articles.title');

        $scope.cms_article = { cms_category_id : $state.params.parent_id};

        let stateGo = "";
        let stateGoParams = {};

        // Controlamos la página por la que hemos venido para volver a ella al cancelar o eliminar
        $scope.standalone = $stateParams.standalone;
        if ($scope.standalone == true) {

            $scope.uiSerf = "cms_articles.list"; 
            stateGo = "cms_articles.list";
            stateGoParams = {};

        } else {
            $scope.uiSerf = "cms_categories.edit({id:cms_article.cms_category_id})";
            stateGo = ("cms_categories.edit");
            stateGoParams = { id: $scope.cms_article.cms_category_id };
        } 
        //languageCode = "es"

        //Gestor de texto 
        $scope.tinymceOptions = {
            resize: true,
            //forced_root_block: 'div',
            min_height: 60,
            height: 60,
            contextmenu: false,
            branding: false,
            schema: "html5",
            formats: {
                bold: { inline: 'b' },
                underline: { inline: 'u' },
                italic: { inline: 'i' },
                alignleft: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div', attributes: { align: "left" } },
                aligncenter: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div', attributes: { align: "center" } },
                alignright: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div', attributes: { align: "right" } },
                alignjustify: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div', attributes: { align: "justify" } },
            },
            invalid_elements: 'strong,em',
            fontsize_formats: "8px 10px 12px 14px 15px 16px 18px 20px 22px 24px 25px 28px 30px 36px ",
            font_formats: 'Arial=Arial;Cambria=Cambria;Courier New=Courier New;Segoe Script=Segoe Script;Tahoma=Tahoma;Verdana=Verdana',
            body_class: 'custom_tinymce_content',
            language: $translate.use().toLowerCase(), //Hay que customizarlo dependiendo del idioma...
            paste_as_text: true,
            plugins: 'paste textcolor code',
            toolbar: "undo redo |  fontsizeselect bold underline italic | forecolor fontselect | alignleft aligncenter alignright alignjustify | code",
            menubar: false
        };

        //
        IconPicker.Init({
            // Required: You have to set the path of IconPicker JSON file to "jsonUrl" option. e.g. '/content/plugins/IconPicker/dist/iconpicker-1.5.0.json'
            jsonUrl: '/assets/iconpicker-1.5.0.json',
            // Optional: Change the buttons or search placeholder text according to the language.
            searchPlaceholder: 'Search Icon',
            showAllButton: 'Show All',
            cancelButton: 'Cancel',
            noResultsFound: 'No results found.', // v1.5.0 and the next versions
            borderRadius: '20px', // v1.5.0 and the next versions
        });

        IconPicker.Run('#GetIconPicker', function () {
            // ng-bind no funciona para asignar el icono porque no detecta el cambio que hacemos con el IconPicker, así que hay que hacerlo a pelo.
            let icon = document.querySelector("#IconPreview").getAttribute("class");
            icon = icon.substring(icon.indexOf('-') + 1);
            $scope.cms_article.icon = icon;
        });

        if ($stateParams.standalone == false) {
            if (angular.isUndefined($stateParams.id) || $stateParams.id == "") {

                $rootScope.breadcrumb = [
                    { title: $filter('translate')('cms_categories.title'), url: `cms_categories.list` },
                    { title: $filter('translate')('cms_categories.title_edit'), url: `cms_categories.edit({ id: ${$scope.cms_article.cms_category_id}})` },
                    { title: $filter('translate')('cms_articles.title_add') },

                ];
            } else {
                $rootScope.breadcrumb = [
                    { title: $filter('translate')('cms_categories.title'), url: `cms_categories.list` },
                    { title: $filter('translate')('cms_categories.edit'), url: `cms_categories.edit({id :  ${$scope.cms_article.cms_category_id}})` },
                    { title: $filter('translate')('cms_articles.edit') },
                ];

                Restangular.one('CmsArticles', $stateParams.id).get().then(function (result) {

                    $scope.cms_article = result;
                });
            }

        } else {

            if (angular.isUndefined($stateParams.id) || $stateParams.id == "") {

                $rootScope.breadcrumb = [
                    { title: $filter('translate')('cms_articles.title'), url: `cms_articles.list` },
                    { title: $filter('translate')('cms_articles.title_add') },

                ];
            } else {
                $rootScope.breadcrumb = [
                    { title: $filter('translate')('cms_articles.title'), url: `cms_articles.list` },
                    { title: $filter('translate')('cms_articles.edit') },
                ];

                Restangular.one('CmsArticles', $stateParams.id).get().then(function (result) {

                    $scope.cms_article = result;
                });
            }
        }
        $scope.save = function () {

            if (!angular.isUndefined($scope.cms_article.id)) {
                $scope.cms_article.put().then(function (result) {
                    if (typeof (result.id) != "undefined") {
                        toastr.success($filter('translate')('cms_articles.modified_success'));
                        $state.go(stateGo, stateGoParams);
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            } else {
                Restangular.all('CmsArticles').post($scope.cms_article).then(function (result) {
                    if (typeof (result.id) != "undefined") {
                        toastr.success($filter('translate')('cms_articles.created_success'));
                        $state.go(stateGo, stateGoParams);
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            }
        }

        $scope.checkDelete = function () {
            modalService.confirm({
                title: $filter('translate')('cms_articles.delete'),
                message: $filter('translate')('cms_articles.delete_message') + " " + $scope.cms_article.title + "?",
                onAccept: function () {
                    $scope.cms_article.remove().then(function () {
                        toastr.success($filter('translate')('cms_articles.remove_success'));
                        $state.go(stateGo, stateGoParams);
                    });
                }
            });
        };

    }])

    ;

